
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9ChZM", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $6SsN4 = parcelRequire("6SsN4");


var $iQxQk = parcelRequire("iQxQk");


var $9DHhW = parcelRequire("9DHhW");


var $lTECB = parcelRequire("lTECB");


var $e4o8D = parcelRequire("e4o8D");


var $iP9x4 = parcelRequire("iP9x4");


var $4IoVL = parcelRequire("4IoVL");


var $gXrHX = parcelRequire("gXrHX");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");





var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $luv00 = parcelRequire("luv00");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $75Ax4 = parcelRequire("75Ax4");


var $2XV0z = parcelRequire("2XV0z");


var $3WPGR = parcelRequire("3WPGR");

/**
 * @generated SignedSource<<d8d30b1c4edc6e16e1af015effc603e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e755fba54182b8bd$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "CoverPictureQuery_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": "coverPictureProperties",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "cover-picture-id-draft",
                            "cover-picture-id-published"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "concreteType": "Version",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "number"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
            }
        ],
        "type": "Content"
    };
}();
$e755fba54182b8bd$var$node.hash = "da6968c7389a1aa4ff7aa70ff9c18a4e";
var $e755fba54182b8bd$export$2e2bcd8739ae039 = $e755fba54182b8bd$var$node;



var $lC6Qd = parcelRequire("lC6Qd");

const $34fb18e1eff4cb9b$export$32667dced0d2dcef = (0, $lC6Qd.default);
const $34fb18e1eff4cb9b$export$dd07106cb209dc71 = (0, $e755fba54182b8bd$export$2e2bcd8739ae039);


const $250035b51418e050$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "img" : t2;
        const { isPresenterMode: isPresenterMode, presenterModeHeight: presenterModeHeight, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFullWidthImageOption: isFullWidthImageOption, isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, isPagePreview: isPagePreview, objectPosition: objectPosition, isRoundedCorners: isRoundedCorners, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_12lctvr": (0, $9aYkv.default)(__cmplp.presenterModeHeight, "px"),
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px"),
                "--_pjvxvw": (0, $9aYkv.default)(__cmplp.dynamicCoverImageHeight, "px"),
                "--_z440ka": (0, $9aYkv.default)(__cmplp.objectPosition)
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_00EA0eiObl _1DCdHiPgdg _39xV02N91d _3iDTPbQ4SZ _1PLshBJ4Kb",
                __cmplp.isPresenterMode ? "_0jFU0VLRSg" : __cmplp.smartSpaceOverviewHeight ? "_0jFU0VyL7s" : __cmplp.isFullWidthImageOption ? "_0jFU0VurUm" : __cmplp.isFixedWidthImageOption ? "_0jFU0V6Tex" : "_0jFU0VYOrR",
                __cmplp.isFixedWidthImageOption && "_39xV02OAqP",
                __cmplp.smartSpaceOverviewHeight ? "_313842Pgdg" : !__cmplp.isPagePreview && "_3138425zaO",
                __cmplp.isRoundedCorners ? "_0bjKvDyzSk" : "_0bjKvDZqHV",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $250035b51418e050$export$caf7b844f87776ef = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_2uo31fGsB2 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _1DCdHiPgdg",
                __cmplp.smartSpaceOverviewHeight ? "_0jFU0Vm31q" : __cmplp.isFixedWidthImageOption ? "_0jFU0V6Tex" : "_0jFU0VurUm",
                __cmplp.isFixedWidthImageOption ? "_2XsHFM5ksT _1EqgXlOAqP" : "_2XsHFM5ksT",
                __cmplp.smartSpaceOverviewHeight ? "_313842Pgdg" : "_3138425zaO",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $250035b51418e050$export$4f4221086883a54f = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, isSpaceOverview: isSpaceOverview, isEmbeddedConfluence: isEmbeddedConfluence, hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_2uo31fGsB2 _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _1DCdHiPgdg _1mT5xdWVPG",
                __cmplp.smartSpaceOverviewHeight ? "_0jFU0Vm31q" : __cmplp.isFixedWidthImageOption ? "_0jFU0V6Tex" : "_0jFU0VurUm",
                __cmplp.isFixedWidthImageOption ? "_39xV02OAqP" : __cmplp.isSpaceOverview || __cmplp.isEmbeddedConfluence ? "_39xV02N91d" : "_39xV02rFfx",
                __cmplp.hasAllowedExternalImageLoaded ? "_0fKRyPnQyn" : "_0fKRyPYvD1",
                __cmplp.smartSpaceOverviewHeight ? "_313842Pgdg" : "_3138425zaO",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $250035b51418e050$var$AllowedExternalWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDZqHV _3iDTPbQ4SZ _37wbyuDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $250035b51418e050$var$IdentifierWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, isPagePreview: isPagePreview, isEmbeddedConfluence: t1, isFixedWidthImageOption: t2, isSmartSpaceOverview: t3 } = t0;
    const isEmbeddedConfluence = t1 === undefined ? false : t1;
    const isFixedWidthImageOption = t2 === undefined ? false : t2;
    const isSmartSpaceOverview = t3 === undefined ? false : t3;
    const t4 = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t5;
    if ($[0] !== isEmbeddedConfluence || $[1] !== isFixedWidthImageOption || $[2] !== isPagePreview || $[3] !== isSmartSpaceOverview) {
        t5 = isPagePreview && isFixedWidthImageOption ? {
            display: "flex",
            justifyContent: "center"
        } : !isPagePreview && !isSmartSpaceOverview ? isFixedWidthImageOption ? {
            marginLeft: "var(--full-cover-image-margin, 0px)",
            width: isEmbeddedConfluence ? "unset" : "var(--full-cover-image-width, 100%)",
            marginTop: "-26px",
            display: isFixedWidthImageOption ? "flex" : "unset",
            justifyContent: isFixedWidthImageOption ? "center" : "unset"
        } : {
            marginLeft: "var(--full-cover-image-margin, 0px)",
            width: isEmbeddedConfluence ? "unset" : "var(--full-cover-image-width, 100%)",
            marginTop: "-26px"
        } : {};
        $[0] = isEmbeddedConfluence;
        $[1] = isFixedWidthImageOption;
        $[2] = isPagePreview;
        $[3] = isSmartSpaceOverview;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== children || $[6] !== t4 || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...t4,
            className: "renderer-page-cover-picture",
            style: t5
        }, children);
        $[5] = children;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
};
const $250035b51418e050$var$getPageMode = (isPagePreview, isSpaceOverview, isPresenterMode, isEmbeddedConfluence, isDiffEditor)=>{
    if (isPagePreview) return 'preview';
    else if (isSpaceOverview) return 'space-overview';
    else if (isPresenterMode) return 'presenter';
    else if (isEmbeddedConfluence) return 'embed';
    else if (isDiffEditor) return 'diff-editor';
    else return 'view';
};
const $250035b51418e050$var$RendererPageCoverPictureResolvedComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(91);
    const { contentId: contentId, isPagePreview: isPagePreview, coverPicture: coverPicture, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, isSmartSpaceOverview: isSmartSpaceOverview, hasEmoji: hasEmoji, leftRightPaddingValue: leftRightPaddingValue, isPresenterMode: isPresenterMode, coverPictureWidthOverride: coverPictureWidthOverride, isDiffEditor: isDiffEditor, useDraftData: useDraftData, titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = t0;
    const { isExternalShareRequest: isExternalShare } = (0, $cozmU.useContext)((0, $gXrHX.ExternalShareContext));
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const [mediaConfig, setMediaConfig] = (0, $cozmU.useState)(null);
    const [hasAllowedExternalImageLoaded, setHasAllowedExternalImageLoaded] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== contentId || $[1] !== isExternalShare) {
        t1 = {
            contentId: contentId,
            isExternalShare: isExternalShare
        };
        $[0] = contentId;
        $[1] = isExternalShare;
        $[2] = t1;
    } else t1 = $[2];
    const ssrConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)(t1);
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const isPageSSRed = isServerPlaceholder || window.__SSR_RENDERED__;
    const isMediaConfigGateReady = isPageSSRed ? !!ssrConfig : !!mediaConfig;
    let t2;
    if ($[3] !== isPageSSRed || $[4] !== mediaConfig || $[5] !== ssrConfig) {
        t2 = isPageSSRed ? ssrConfig && ssrConfig.config : mediaConfig && {
            authProvider: mediaConfig.authProvider
        };
        $[3] = isPageSSRed;
        $[4] = mediaConfig;
        $[5] = ssrConfig;
        $[6] = t2;
    } else t2 = $[6];
    const mediaConfigGated = t2;
    const isFixedWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED || coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const isFixedWidthImageOption = !isPresenterMode && isFixedWidth;
    const isFullWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FULL || coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const isFullWidthImageOption = !isPresenterMode && isFullWidth;
    const isValidCustomSitesTitleAlignment = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER || titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).LEFT;
    const titleAlignment = isValidCustomSitesTitleAlignment && titleContentProperties && titleContentProperties.titleLayoutAlignment ? titleContentProperties.titleLayoutAlignment : "";
    const leftRightPaddingValueOffset = isPagePreview && leftRightPaddingValue ? leftRightPaddingValue : 0;
    const { height: height } = (0, $2XV0z.usePageHeightWidthObserver)(isPagePreview, leftRightPaddingValueOffset, isPresenterMode);
    const smartSpaceOverviewHeight = isSmartSpaceOverview ? (0, $75Ax4.SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH) : undefined;
    const dynamicHeight = isFixedWidthImageOption ? (0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT) : height;
    const imageId = (isPagePreview || useDraftData ? coverPicture.draft?.value.id : coverPicture.published?.value.id) || "";
    const position = (isPagePreview || useDraftData ? coverPicture.draft?.value.position : coverPicture.published?.value.position) || "";
    const objectPosition = `center ${position}%`;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    if ($[7] !== imageId) {
        t3 = !!imageId && (0, $3WPGR.isAllowedExternalCoverPictureUrl)(imageId);
        $[7] = imageId;
        $[8] = t3;
    } else t3 = $[8];
    const isAllowedExternalCoverPicture = t3;
    const currentPageMode = $250035b51418e050$var$getPageMode(isPagePreview, isSpaceOverview, isPresenterMode, isEmbeddedConfluence, isDiffEditor);
    let t4;
    if ($[9] !== createAnalyticsEvent) {
        t4 = (isUnsplash, appearance_0, pageMode, pageTitleAlignment, isFixedWidthCoverImage)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "viewed",
                    actionSubject: "HeaderImage",
                    actionSubjectId: "viewPageHeaderImage",
                    source: "viewPageHeaderImage",
                    attributes: {
                        headerImageType: isUnsplash ? "unsplash" : "user-uploaded",
                        contentAppearance: appearance_0,
                        pageMode: pageMode,
                        pageTitleAlignment: pageTitleAlignment,
                        coverImageWidth: isFixedWidthCoverImage ? "fixed-width" : "full-width",
                        isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)("cc_page_experiences_ai_header_image_generation"),
                        isAIFCAutoGeneratedImageEnabled: (0, $6mKj3.isExperimentEnabled)("cc_page_experiences_aifc_auto_generated_header_img")
                    }
                }
            }).fire();
        };
        $[9] = createAnalyticsEvent;
        $[10] = t4;
    } else t4 = $[10];
    const createViewHeaderImageAnalyticsEvent = t4;
    let t5;
    let t6;
    if ($[11] !== appearance || $[12] !== createViewHeaderImageAnalyticsEvent || $[13] !== currentPageMode || $[14] !== isAllowedExternalCoverPicture || $[15] !== isFixedWidthImageOption || $[16] !== titleAlignment) {
        t5 = ()=>{
            createViewHeaderImageAnalyticsEvent(isAllowedExternalCoverPicture, appearance, currentPageMode, titleAlignment, isFixedWidthImageOption);
        };
        t6 = [
            isAllowedExternalCoverPicture,
            appearance,
            currentPageMode,
            titleAlignment,
            isFixedWidthImageOption,
            createViewHeaderImageAnalyticsEvent
        ];
        $[11] = appearance;
        $[12] = createViewHeaderImageAnalyticsEvent;
        $[13] = currentPageMode;
        $[14] = isAllowedExternalCoverPicture;
        $[15] = isFixedWidthImageOption;
        $[16] = titleAlignment;
        $[17] = t5;
        $[18] = t6;
    } else {
        t5 = $[17];
        t6 = $[18];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[19] !== contentId || $[20] !== isExternalShare || $[21] !== setMediaConfig) {
        t7 = ()=>{
            let isMounted = true;
            setMediaConfig(null);
            (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                isExternalShare: isExternalShare
            }).then((t8)=>{
                const { viewMediaClientConfig: viewMediaClientConfig } = t8;
                if (isMounted) setMediaConfig({
                    collection: `contentId-${contentId}`,
                    authProvider: viewMediaClientConfig.authProvider
                });
            });
            return ()=>{
                isMounted = false;
            };
        };
        $[19] = contentId;
        $[20] = isExternalShare;
        $[21] = setMediaConfig;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== contentId || $[24] !== isExternalShare) {
        t8 = [
            contentId,
            isExternalShare
        ];
        $[23] = contentId;
        $[24] = isExternalShare;
        $[25] = t8;
    } else t8 = $[25];
    (0, $cozmU.useEffect)(t7, t8);
    if (!isMediaConfigGateReady || !imageId && !isAllowedExternalCoverPicture) {
        let t9;
        if ($[26] !== isFixedWidthImageOption || $[27] !== isPagePreview || $[28] !== isSpaceOverview || $[29] !== smartSpaceOverviewHeight) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$export$caf7b844f87776ef, {
                isPagePreview: isPagePreview,
                isSpaceOverview: isSpaceOverview,
                isFixedWidthImageOption: isFixedWidthImageOption,
                smartSpaceOverviewHeight: smartSpaceOverviewHeight
            });
            $[26] = isFixedWidthImageOption;
            $[27] = isPagePreview;
            $[28] = isSpaceOverview;
            $[29] = smartSpaceOverviewHeight;
            $[30] = t9;
        } else t9 = $[30];
        let t10;
        if ($[31] !== isEmbeddedConfluence || $[32] !== isFixedWidthImageOption || $[33] !== isPagePreview || $[34] !== isSmartSpaceOverview || $[35] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$var$IdentifierWrapper, {
                isPagePreview: isPagePreview,
                isEmbeddedConfluence: isEmbeddedConfluence,
                isFixedWidthImageOption: isFixedWidthImageOption,
                isSmartSpaceOverview: isSmartSpaceOverview
            }, t9);
            $[31] = isEmbeddedConfluence;
            $[32] = isFixedWidthImageOption;
            $[33] = isPagePreview;
            $[34] = isSmartSpaceOverview;
            $[35] = t9;
            $[36] = t10;
        } else t10 = $[36];
        return t10;
    }
    if (isAllowedExternalCoverPicture) {
        let t9;
        if ($[37] !== hasAllowedExternalImageLoaded || $[38] !== isEmbeddedConfluence || $[39] !== isFixedWidthImageOption || $[40] !== isPagePreview || $[41] !== isSpaceOverview || $[42] !== smartSpaceOverviewHeight) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$export$4f4221086883a54f, {
                isPagePreview: isPagePreview,
                hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded,
                isSpaceOverview: isSpaceOverview,
                isEmbeddedConfluence: isEmbeddedConfluence,
                isFixedWidthImageOption: isFixedWidthImageOption,
                smartSpaceOverviewHeight: smartSpaceOverviewHeight
            });
            $[37] = hasAllowedExternalImageLoaded;
            $[38] = isEmbeddedConfluence;
            $[39] = isFixedWidthImageOption;
            $[40] = isPagePreview;
            $[41] = isSpaceOverview;
            $[42] = smartSpaceOverviewHeight;
            $[43] = t9;
        } else t9 = $[43];
        let t10;
        if ($[44] !== setHasAllowedExternalImageLoaded) {
            t10 = ()=>{
                setHasAllowedExternalImageLoaded(true);
            };
            $[44] = setHasAllowedExternalImageLoaded;
            $[45] = t10;
        } else t10 = $[45];
        const t11 = isPresenterMode ? dynamicHeight : undefined;
        let t12;
        if ($[46] !== hasEmoji || $[47] !== imageId || $[48] !== isFixedWidthImageOption || $[49] !== isFullWidthImageOption || $[50] !== isPagePreview || $[51] !== isPresenterMode || $[52] !== isSmartSpaceOverview || $[53] !== isSpaceOverview || $[54] !== objectPosition || $[55] !== smartSpaceOverviewHeight || $[56] !== t10 || $[57] !== t11) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$export$75f07c36086c2c81, {
                "data-testid": "unsplash-cover-picture",
                "data-vc": "unsplash-cover-picture-renderer",
                alt: "",
                isPagePreview: isPagePreview,
                src: imageId,
                objectPosition: objectPosition,
                onLoad: t10,
                isSpaceOverview: isSpaceOverview,
                isRoundedCorners: isSmartSpaceOverview,
                hasEmoji: hasEmoji,
                dynamicCoverImageHeight: undefined,
                presenterModeHeight: t11,
                isPresenterMode: isPresenterMode,
                isFixedWidthImageOption: isFixedWidthImageOption,
                smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                isFullWidthImageOption: isFullWidthImageOption
            });
            $[46] = hasEmoji;
            $[47] = imageId;
            $[48] = isFixedWidthImageOption;
            $[49] = isFullWidthImageOption;
            $[50] = isPagePreview;
            $[51] = isPresenterMode;
            $[52] = isSmartSpaceOverview;
            $[53] = isSpaceOverview;
            $[54] = objectPosition;
            $[55] = smartSpaceOverviewHeight;
            $[56] = t10;
            $[57] = t11;
            $[58] = t12;
        } else t12 = $[58];
        let t13;
        if ($[59] !== imageId || $[60] !== t12 || $[61] !== t9) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$var$AllowedExternalWrapper, {
                key: imageId
            }, t9, t12);
            $[59] = imageId;
            $[60] = t12;
            $[61] = t9;
            $[62] = t13;
        } else t13 = $[62];
        let t14;
        if ($[63] !== isEmbeddedConfluence || $[64] !== isFixedWidthImageOption || $[65] !== isPagePreview || $[66] !== isSmartSpaceOverview || $[67] !== t13) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$var$IdentifierWrapper, {
                isPagePreview: isPagePreview,
                isEmbeddedConfluence: isEmbeddedConfluence,
                isFixedWidthImageOption: isFixedWidthImageOption,
                isSmartSpaceOverview: isSmartSpaceOverview
            }, t13);
            $[63] = isEmbeddedConfluence;
            $[64] = isFixedWidthImageOption;
            $[65] = isPagePreview;
            $[66] = isSmartSpaceOverview;
            $[67] = t13;
            $[68] = t14;
        } else t14 = $[68];
        return t14;
    } else if (isMediaConfigGateReady && mediaConfigGated) {
        const t9 = isPageSSRed ? `contentId-${contentId}` : mediaConfig?.collection;
        let t10;
        if ($[69] !== imageId || $[70] !== t9) {
            t10 = {
                mediaItemType: "file",
                id: imageId,
                collectionName: t9
            };
            $[69] = imageId;
            $[70] = t9;
            $[71] = t10;
        } else t10 = $[71];
        let t11;
        if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = {
                allowAnimated: true,
                mode: "full-fit",
                upscale: false
            };
            $[72] = t11;
        } else t11 = $[72];
        const t12 = isPageSSRed ? ssrConfig?.mode : undefined;
        let t13;
        if ($[73] !== dynamicHeight || $[74] !== hasEmoji || $[75] !== isEmbeddedConfluence || $[76] !== isFixedWidthImageOption || $[77] !== isFullWidthImageOption || $[78] !== isPagePreview || $[79] !== isPresenterMode || $[80] !== isSmartSpaceOverview || $[81] !== isSpaceOverview || $[82] !== objectPosition || $[83] !== smartSpaceOverviewHeight) {
            t13 = (t14)=>{
                const { data: data, loading: loading } = t14;
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$var$IdentifierWrapper, {
                    isPagePreview: isPagePreview,
                    isEmbeddedConfluence: isEmbeddedConfluence,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    isSmartSpaceOverview: isSmartSpaceOverview
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$export$caf7b844f87776ef, {
                    isPagePreview: isPagePreview,
                    isSpaceOverview: isSpaceOverview,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    smartSpaceOverviewHeight: smartSpaceOverviewHeight
                }));
                if (!data) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$var$IdentifierWrapper, {
                    isPagePreview: isPagePreview,
                    isEmbeddedConfluence: isEmbeddedConfluence,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    isSmartSpaceOverview: isSmartSpaceOverview
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$export$75f07c36086c2c81, {
                    isPagePreview: isPagePreview,
                    src: data.src,
                    objectPosition: objectPosition,
                    isSpaceOverview: isSpaceOverview,
                    isRoundedCorners: isSmartSpaceOverview,
                    hasEmoji: hasEmoji,
                    dynamicCoverImageHeight: undefined,
                    presenterModeHeight: isPresenterMode ? dynamicHeight : undefined,
                    isPresenterMode: isPresenterMode,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                    isFullWidthImageOption: isFullWidthImageOption,
                    alt: ""
                }));
            };
            $[73] = dynamicHeight;
            $[74] = hasEmoji;
            $[75] = isEmbeddedConfluence;
            $[76] = isFixedWidthImageOption;
            $[77] = isFullWidthImageOption;
            $[78] = isPagePreview;
            $[79] = isPresenterMode;
            $[80] = isSmartSpaceOverview;
            $[81] = isSpaceOverview;
            $[82] = objectPosition;
            $[83] = smartSpaceOverviewHeight;
            $[84] = t13;
        } else t13 = $[84];
        let t14;
        if ($[85] !== imageId || $[86] !== mediaConfigGated || $[87] !== t10 || $[88] !== t12 || $[89] !== t13) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iQxQk.MediaImageWithErrorBoundary), {
                key: imageId,
                identifier: t10,
                mediaClientConfig: mediaConfigGated,
                apiConfig: t11,
                ssr: t12
            }, t13);
            $[85] = imageId;
            $[86] = mediaConfigGated;
            $[87] = t10;
            $[88] = t12;
            $[89] = t13;
            $[90] = t14;
        } else t14 = $[90];
        return t14;
    }
};
const $250035b51418e050$var$RendererPageCoverPictureQueryReader = (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props.contentId) {
        t0 = {
            contentId: props.contentId
        };
        $[0] = props.contentId;
        $[1] = t0;
    } else t0 = $[1];
    const titleContentData = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t0);
    let t1;
    if ($[2] !== props || $[3] !== titleContentData) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$var$RendererPageCoverPictureResolvedComponent, {
            ...props,
            ...titleContentData
        });
        $[2] = props;
        $[3] = titleContentData;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};
const $250035b51418e050$var$RendererPageCoverPictureFragmentReader = (props)=>{
    const $ = (0, $bDgLe.c)(12);
    const titleContent = (0, $6SsN4.useFragment)((0, $zalpJ.useTitleContentPropertiesForPublishedPage_content), props.titleContentFragmentRef);
    const coverPictureContent = (0, $6SsN4.useFragment)((0, $34fb18e1eff4cb9b$export$dd07106cb209dc71), props.coverPictureFragmentRef);
    let t0;
    if ($[0] !== titleContent) {
        t0 = (0, $zalpJ.getTitleContentProperty)({
            content: {
                nodes: [
                    titleContent
                ]
            }
        });
        $[0] = titleContent;
        $[1] = t0;
    } else t0 = $[1];
    const titleContentData = t0;
    let t1;
    let t2;
    if ($[2] !== coverPictureContent.coverPictureProperties?.nodes) {
        const coverPictureProperties = coverPictureContent.coverPictureProperties?.nodes ?? [];
        t1 = (0, $3WPGR.propertyToId)(coverPictureProperties.find($250035b51418e050$var$_temp));
        t2 = (0, $3WPGR.propertyToId)(coverPictureProperties.find($250035b51418e050$var$_temp2));
        $[2] = coverPictureContent.coverPictureProperties?.nodes;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = {
            draft: t1,
            published: t2
        };
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const coverPicture = t3;
    let t4;
    if ($[8] !== coverPicture || $[9] !== props || $[10] !== titleContentData) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$var$RendererPageCoverPictureResolvedComponent, {
            ...props,
            ...titleContentData,
            coverPicture: coverPicture
        });
        $[8] = coverPicture;
        $[9] = props;
        $[10] = titleContentData;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
};
const $250035b51418e050$export$d8da1ed12fdbdfd1 = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    if (props.titleContentFragmentRef && props.coverPictureFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_title_byline_frag_dedup") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$var$RendererPageCoverPictureFragmentReader, {
                ...props,
                titleContentFragmentRef: props.titleContentFragmentRef,
                coverPictureFragmentRef: props.coverPictureFragmentRef
            });
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($250035b51418e050$var$RendererPageCoverPictureQueryReader, props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
const $250035b51418e050$export$60620c3d63f5f30 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($250035b51418e050$export$d8da1ed12fdbdfd1);
function $250035b51418e050$var$_temp(property) {
    return property?.key === "cover-picture-id-draft";
}
function $250035b51418e050$var$_temp2(property_0) {
    return property_0?.key === "cover-picture-id-published";
}
module.exports["ImageWrapper"] = $250035b51418e050$export$75f07c36086c2c81;
module.exports["LoadingDiv"] = $250035b51418e050$export$caf7b844f87776ef;
module.exports["AllowedExternalLoadingDiv"] = $250035b51418e050$export$4f4221086883a54f;
module.exports["RendererPageCoverPictureComponent"] = $250035b51418e050$export$d8da1ed12fdbdfd1;
module.exports["RendererPageCoverPicture"] = $250035b51418e050$export$60620c3d63f5f30;

});

parcelRegister("gXrHX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("2XV0z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cMvQV = parcelRequire("cMvQV");


var $3WPGR = parcelRequire("3WPGR");

const $8c9f801fa4f4ae90$export$a5c14cb4205739db = (isPagePreview, leftRightPaddingValueOffset, isPresenterMode)=>{
    const $ = (0, $bDgLe.c)(9);
    const [height, setHeight] = (0, $cozmU.useState)(0);
    const [width, setWidth] = (0, $cozmU.useState)(0);
    const [leftOffset, setLeftOffset] = (0, $cozmU.useState)(0);
    const observerRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== isPagePreview || $[1] !== isPresenterMode || $[2] !== leftOffset || $[3] !== leftRightPaddingValueOffset) {
        t0 = ()=>{
            let queryId;
            if (isPresenterMode) queryId = "[id='presenter-mode-header-image-container']";
            else if (isPagePreview) queryId = "[id='header-row-wrapper']";
            else queryId = ".content-screen-component";
            const pageScrollParent = document.querySelector(queryId);
            if (pageScrollParent) {
                observerRef.current = new ResizeObserver((entries)=>{
                    if ((0, $cMvQV.isChrome)() || (0, $cMvQV.isSafari)()) {
                        const innerWidth = Math.floor(entries[0]?.target.clientWidth);
                        const outerWidth = Math.floor(entries[0]?.borderBoxSize?.[0].inlineSize);
                        if (outerWidth > innerWidth) setLeftOffset(outerWidth - innerWidth);
                    }
                    const currentWidth = Math.floor(entries[0]?.target.clientWidth) - leftOffset - leftRightPaddingValueOffset;
                    setWidth(currentWidth);
                    setHeight((0, $3WPGR.getDynamicCoverImageHeight)(currentWidth));
                });
                observerRef.current.observe(pageScrollParent);
                return ()=>observerRef?.current?.disconnect();
            }
        };
        t1 = [
            observerRef,
            leftOffset,
            isPagePreview,
            leftRightPaddingValueOffset,
            isPresenterMode
        ];
        $[0] = isPagePreview;
        $[1] = isPresenterMode;
        $[2] = leftOffset;
        $[3] = leftRightPaddingValueOffset;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[6] !== height || $[7] !== width) {
        t2 = {
            height: height,
            width: width
        };
        $[6] = height;
        $[7] = width;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
module.exports["usePageHeightWidthObserver"] = $8c9f801fa4f4ae90$export$a5c14cb4205739db;

});

parcelRegister("lC6Qd", function(module, exports) {
/**
 * @generated SignedSource<<809e2044c3792f08e4a1f1fd3c386e1c>>
 * @relayHash eca6e9d325c97f4fd5880178ecc63561
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d
const $03de5ecc01e321ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "eca6e9d325c97f4fd5880178ecc63561",
            "id": "e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d",
            "metadata": {},
            "name": "CoverPictureQuery",
            "operationKind": "query",
            "text": "query CoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$03de5ecc01e321ee$var$node.hash = "cbe85309884dfe8220661d705f977e0f";
var $03de5ecc01e321ee$export$2e2bcd8739ae039 = $03de5ecc01e321ee$var$node;
module.exports["default"] = $03de5ecc01e321ee$export$2e2bcd8739ae039;

});

parcelRegister("hEt1x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $IY7Mb = parcelRequire("IY7Mb");

const $2ddf178f2decc0e9$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2ddf178f2decc0e9$export$57164260bc1f1218 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $2ddf178f2decc0e9$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $2ddf178f2decc0e9$export$57164260bc1f1218;

});

parcelRegister("IY7Mb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gYqFD = parcelRequire("gYqFD");

const $a0017e6c99530c15$export$d54af28440a5efc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $cozmU.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $a0017e6c99530c15$export$d54af28440a5efc0;

});

parcelRegister("gYqFD", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $c55cff04bbd4c82d$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $c55cff04bbd4c82d$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($c55cff04bbd4c82d$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $c55cff04bbd4c82d$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $c55cff04bbd4c82d$export$2d23ed2854ac1650 = $c55cff04bbd4c82d$export$7e209e67b965bc63($c55cff04bbd4c82d$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $c55cff04bbd4c82d$export$2d23ed2854ac1650;

});

parcelRegister("lNvN4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");

const $e5ff9295aa55af63$export$8b3e87ea56c3a345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $e5ff9295aa55af63$export$8b3e87ea56c3a345;

});

parcelRegister("4fGOw", function(module, exports) {

var $jx5V5 = parcelRequire("jx5V5");


var $lNvN4 = parcelRequire("lNvN4");

const $dc2272ad9447ddc9$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $jx5V5.useStore)(store, selector, equals);
function $dc2272ad9447ddc9$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $dc2272ad9447ddc9$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $dc2272ad9447ddc9$export$8a9cc8c330400af8;

});

parcelRegister("jx5V5", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $e385b0e7bfdc7f87$export$6ccbb43953eebf8);

var $3xeSM = parcelRequire("3xeSM");


var $cozmU = parcelRequire("cozmU");


var $aSzLn = parcelRequire("aSzLn");

var $e385b0e7bfdc7f87$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $e385b0e7bfdc7f87$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU)));
const { useSyncExternalStoreWithSelector: $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($aSzLn)));
let $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = false;
const $e385b0e7bfdc7f87$var$identity = (arg)=>arg;
function $e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector = $e385b0e7bfdc7f87$var$identity, equalityFn) {
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$e385b0e7bfdc7f87$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = true;
    }
    const slice = $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $e385b0e7bfdc7f87$var$useDebugValue(slice);
    return slice;
}
const $e385b0e7bfdc7f87$var$createImpl = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $3xeSM.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $e385b0e7bfdc7f87$export$185802fd694ee1f5 = (createState)=>createState ? $e385b0e7bfdc7f87$var$createImpl(createState) : $e385b0e7bfdc7f87$var$createImpl;
var $e385b0e7bfdc7f87$export$2e2bcd8739ae039 = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $e385b0e7bfdc7f87$export$185802fd694ee1f5(createState);
};

});

parcelRegister("cvZVo", function(module, exports) {
const $b878f2b45b924d24$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
module.exports["isImageRepresentationReady"] = $b878f2b45b924d24$export$4e33ccde53b4f0bf;

});

parcelRegister("2j0AL", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("6AroL", function(module, exports) {
function $4cbb5ba451601f11$var$e(e) {
    this.message = e;
}
$4cbb5ba451601f11$var$e.prototype = new Error, $4cbb5ba451601f11$var$e.prototype.name = "InvalidCharacterError";
var $4cbb5ba451601f11$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $4cbb5ba451601f11$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $4cbb5ba451601f11$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($4cbb5ba451601f11$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $4cbb5ba451601f11$var$r(t);
    }
}
function $4cbb5ba451601f11$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $4cbb5ba451601f11$var$o(e, r) {
    if ("string" != typeof e) throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($4cbb5ba451601f11$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$4cbb5ba451601f11$export$b9721ef022f71a68.prototype = new Error, $4cbb5ba451601f11$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $4cbb5ba451601f11$export$2e2bcd8739ae039 = $4cbb5ba451601f11$var$o;
 //# sourceMappingURL=jwt-decode.esm.js.map
module.exports["default"] = $4cbb5ba451601f11$export$2e2bcd8739ae039;

});


//# sourceMappingURL=RendererPageCoverPicture.1c46621d.js.map
